import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=6a582e4c&scoped=true&"
import script from "./DocumentUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=6a582e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a582e4c",
  null
  
)

export default component.exports